// extracted by mini-css-extract-plugin
export var highlightFade = "_2d-4";
export var highlighted = "_2d-3";
export var table = "_2d-1";
export var tableContainer = "_2d-0";
export var totalsRow = "_2d-2";